import React, { Component } from 'react';
import './Error.css';

class Error extends Component {

    render() {
        return ( 
            <div className="error">{this.props.message}</div>
        );
    }
}

export default Error;


// WEBPACK FOOTER //
// ./src/components/Error/Error.js